import { WizardStep } from "../../ui/wizard"
import { NeutralButton } from "../../common/Buttons"
import { useState, useEffect, useRef } from "react"
import { FaPlus, FaCheck } from "react-icons/fa"
import { Input } from "@chakra-ui/react"
import { colors } from "../../../utilities/colors"
import { CloseButton } from "@chakra-ui/react"

export default function AuditUnitAddPhoto({ auditData, setAuditData, nextStep }) {
  const [showInput, setShowInput] = useState(false)
  const [inputValue, setInputValue] = useState("")
  const inputRef = useRef(null)

  useEffect(() => {
    if (showInput && inputRef.current) {
      inputRef.current.focus()
    }
  }, [showInput])

  const handleAddPhoto = () => {
    setShowInput(true)
  }

  const handleInputSubmit = (e) => {
    if ((e.key === 'Enter' || e.type === 'click') && inputValue.trim()) {
      setAuditData(prev => ({
        ...prev,
        images: {
          ...prev.images,
          [inputValue]: null
        }
      }))
      setInputValue("")
      setShowInput(false)
    }
  }

  return (
    <WizardStep>
      <div className="flex flex-col items-center justify-between pt-6 rounded w-full h-full">
        <div className="flex flex-col items-center justify-center w-full md:w-4/5">
          {Object.keys(auditData.images).map((key) => (
            <div key={key} className="flex flex-row items-center justify-center w-4/5">
              <FaCheck className="text-green mr-2" />
              <p>{key}</p>
            </div>
          ))}
          {showInput && (
            <div className="flex flex-col items-center justify-center w-full md:w-4/5 px-2">
              <div className="flex flex-row items-center justify-center w-full mt-10 mb-2">
                <Input
                  ref={inputRef}
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  onKeyDown={handleInputSubmit}
                  placeholder="Enter photo name"
                  bgColor={colors.grey900}
                  borderRadius='md'
                  _focus={{ borderColor: colors.grey100, ringColor: colors.grey100 }}
                  className="w-full mr-2"
                />
                <CloseButton
                  bg={colors.fpxRed}
                  color={colors.grey900}
                  size={'sm'}
                  className="text-xl text-fpx-red mr-2"
                  onClick={() => setShowInput(false)}
                />
              </div>

              <NeutralButton
                text="Add Photo"
                className="text-xl text-green w-full"
                onClick={handleInputSubmit}
              />
            </div>
          )}
        </div>
        <div className="flex flex-col items-center justify-center w-full md:w-4/5">
          {!showInput &&
            <>
              <NeutralButton
                text={
                  <>
                    <FaPlus className="mr-2" />
                    Add Photo
                  </>
                }
                style="flex w-4/5 mb-4"
                onClick={handleAddPhoto}
              />
              <NeutralButton
                text="Continue"
                style="flex w-4/5"
                onClick={() => nextStep()}
              />
            </>
          }

        </div>
      </div>
    </WizardStep>
  )
}
